import { useContext } from 'react';
import { DocumentCompareContext } from '../context';
import { DocumentCompareAction, FileToCompare } from '../types';

export const useDocumentCompare = () => {
    const context = useContext(DocumentCompareContext);

    if (context === undefined) {
        throw new Error('useDocumentCompare must be used within a DocumentCompareProvider');
    }

    const { state, dispatch } = context;

    const enterCompareMode = (structureId: string) => {
        dispatch({ type: DocumentCompareAction.EnterCompareMode, payload: structureId });
    };

    const exitCompareMode = () => {
        dispatch({ type: DocumentCompareAction.ExitCompareMode });
    };

    const setFirstFile = (file: FileToCompare | null) => {
        dispatch({ type: DocumentCompareAction.SetFirstFile, payload: file });
    };

    const setSecondFile = (file: FileToCompare | null) => {
        dispatch({ type: DocumentCompareAction.SetSecondFile, payload: file });
    };

    const clearFiles = () => {
        dispatch({ type: DocumentCompareAction.ClearFiles });
    };

    return {
        ...state,
        enterCompareMode,
        exitCompareMode,
        setFirstFile,
        setSecondFile,
        clearFiles,
    };
};
